   <div class="background page-wrap" >
    <mat-card class="center-card">
      <mat-card-title>
        <span>Domain Login Successful</span>
      </mat-card-title>
      <mat-card-content>
        <div class="pb-1">
          Registering credentials with Dash Server.... 
        </div>
        <!-- <button mat-raised-button class="mat-primary full-width mb-1" [routerLink]="['/sessions/signin']">Try
          Again</button> -->
          <div class="spinner">
            <div class="double-bounce1 mat-bg-primary"></div>
            <div class="double-bounce2 mat-bg-accent"></div>
          </div>
      </mat-card-content>
    </mat-card>
  </div>

 
